<!-- Wrapper del grid (para contener botón flotante + drawer) -->
<div class="smart-grid-wrapper"
     #gridWrapper
     [class.drawer-open]="isSettingsPanelOpen">
  <!-- Etiqueta tipo bookmark de settings (absolute positioning, pegado al borde derecho) -->

  <span *ngIf="isSettingsPanelEnabled()"  (click)="toggleSettingsPanel()" matTooltipPosition="left" matTooltip="Configuración de tabla" class="tab-text settings-tab">Columnas</span>


  <!-- Grid Container (removed sidenav container for z-index fix) -->
  <div class="smart-grid-container"
           [style.height]="mergedConfig.styling?.height"
           [style.max-height]="mergedConfig.styling?.maxHeight"
           [style.min-height]="mergedConfig.styling?.minHeight"
           [ngStyle]="getContainerStyles()"
           [ngClass]="[mergedConfig.styling?.gridClass || '', responsiveClasses]">
        <!-- Loading Overlay -->
        <div *ngIf="loading" class="smart-grid-loading-overlay">
          <div class="loading-spinner">
            <mat-icon class="animate-spin">hourglass_empty</mat-icon>
            <p>{{ mergedConfig.loading?.loadingText || 'Cargando...' }}</p>
          </div>
        </div>

  <!-- Toolbar Section -->
  <div *ngIf="mergedConfig.search?.enabled && mergedConfig.search?.showSearchInput"
       class="smart-grid-toolbar">

    <!-- Global Search -->
    <div *ngIf="mergedConfig.search?.enabled && mergedConfig.search?.showSearchInput"
         class="toolbar-right flex-1">
      <app-global-search
        [placeholder]="mergedConfig.search?.placeholder || 'Buscar...'"
        [debounceTime]="mergedConfig.search?.debounceTime || 300"
        [showResultCount]="true"
        [totalResults]="dataSource.data.length"
        [initialValue]="searchTerm"
        (searchChanged)="onSearchChanged($event)"
        (searchCleared)="onSearchCleared()">
      </app-global-search>
    </div>
  </div>

  <!-- Group Panel (if grouping is enabled) -->
  <app-group-panel
    *ngIf="mergedConfig.grouping?.enabled && mergedConfig.grouping?.showGroupPanel !== false"
    [groupByFields]="getGroupBy()"
    [fieldLabels]="mergedConfig.grouping?.fieldLabels"
    [panelText]="mergedConfig.grouping?.panelText || 'Arrastra columnas aquí para agrupar'"
    [allowUngroup]="mergedConfig.grouping?.allowUngroup !== false"
    (groupByChanged)="onGroupByChanged($event)">
  </app-group-panel>

  <!-- Grid Table Wrapper -->
  <div class="smart-grid-table-wrapper">
    <!-- ============================================ -->
    <!-- NON-VIRTUAL SCROLLING MODE (Mat-Table) -->
    <!-- ============================================ -->
    <ng-container *ngIf="!isVirtualScrollingEnabled()">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="bg-transparent"
        multiTemplateDataRows>

        <!-- Tree Expand Column -->
        <ng-container *ngIf="isTreeModeEnabled() && mergedConfig.treeData?.showExpandControls !== false" matColumnDef="treeExpand">
          <!-- Header (Empty) -->
          <th mat-header-cell *matHeaderCellDef class="text-left" style="width: 50px;"></th>

          <!-- Body (Tree Expand/Collapse Button with Indentation) -->
          <td mat-cell *matCellDef="let row" class="text-left">
            <app-tree-expand-column
              [expanded]="isTreeNodeExpanded(row)"
              [hasChildren]="hasTreeChildren(row)"
              [level]="getTreeNodeLevel(row)"
              [indentSize]="getTreeIndentSize()"
              (toggle)="toggleTreeNodeExpansion(row)">
            </app-tree-expand-column>
          </td>

          <!-- Footer (Empty) -->
          <ng-container *ngIf="isFooterEnabled()">
            <td mat-footer-cell *matFooterCellDef class="text-left footer-cell"></td>
          </ng-container>
        </ng-container>

        <!-- Expansion Column -->
        <ng-container *ngIf="isRowExpansionEnabled()" matColumnDef="expansion">
          <!-- Header (Empty) -->
          <th mat-header-cell *matHeaderCellDef class="text-left" style="width: 50px;"></th>

          <!-- Body (Expand/Collapse Button) -->
          <td mat-cell *matCellDef="let row" class="text-left">
            <app-expansion-column
              [expanded]="isRowExpanded(getDataFromNode(row) || row)"
              (toggle)="toggleRowExpansion(getDataFromNode(row) || row)">
            </app-expansion-column>
          </td>

          <!-- Footer (Empty) -->
           <ng-container *ngIf="isFooterEnabled()" >
          <td mat-footer-cell *matFooterCellDef class="text-left footer-cell"></td>
           </ng-container>
        </ng-container>

        <!-- Selection Column (Checkbox) -->
        <ng-container *ngIf="isSelectionEnabled() && mergedConfig.selection?.showCheckboxColumn" matColumnDef="selection">
          <!-- Header Checkbox -->
          <th mat-header-cell *matHeaderCellDef class="text-left" style="width: 60px;">
            <app-selection-column
              [checked]="isAllSelected()"
              [indeterminate]="isSomeSelected()"
              (selectionChange)="toggleSelectAll()">
            </app-selection-column>
          </th>

          <!-- Body Checkbox -->
          <td mat-cell *matCellDef="let row; let rowIndex = index" class="text-left">
            <app-selection-column
              [checked]="isRowSelected(getDataFromNode(row) || row)"
              [disabled]="!isRowSelectable(getDataFromNode(row) || row)"
              (selectionChange)="toggleRowSelection(getDataFromNode(row) || row, rowIndex)">
            </app-selection-column>
          </td>

          <!-- Footer (Empty) -->
           <ng-container *ngIf="isFooterEnabled()" >
          <td mat-footer-cell *matFooterCellDef class="text-left footer-cell"></td>
           </ng-container>
        </ng-container>

        <!-- Dynamic Column Definitions -->
        <ng-container
          *ngFor="let colDef of visibleColumnDefs; let colIndex = index; trackBy: trackByColumnId"
          [matColumnDef]="getColumnId(colDef, colIndex)">

          <!-- Header Cell -->
          <th mat-header-cell
              *matHeaderCellDef
              [mat-sort-header]="getSortHeader(colDef)"
              [disabled]="colDef.sortable === false"
              class="text-left"
              [class.pinned-left]="colDef.pinned === 'left'"
              [class.pinned-right]="colDef.pinned === 'right'"
              [class.smart-grid-sortable]="colDef.sortable !== false"
              [class.column-filtered]="isColumnFiltered(colDef)"
              [ngClass]="colDef.headerClass || ''"
              [ngStyle]="getColumnStyles(colDef)">
            <span class="flex items-center gap-1">
              <span class="flex items-center gap-1">
                <!-- Custom Header Renderer or Default Header -->
                <ng-container *ngIf="hasHeaderRenderer(colDef); else defaultHeader">
                  <app-header-renderer-loader
                    [renderer]="colDef.headerRenderer!"
                    [params]="getHeaderRendererParams(colDef, colIndex)">
                  </app-header-renderer-loader>
                </ng-container>
                <ng-template #defaultHeader>
                  {{ getHeaderName(colDef) }}
                </ng-template>
                <span *ngIf="getSortPriority(colDef)"
                      class="sort-priority-badge">
                  {{ getSortPriority(colDef) }}
                </span>
              </span>

              <!-- Column Filter -->
              <app-column-filter
                *ngIf="isFilterableColumn(colDef)"
                [filterOptions]="getFilterOptions(colDef)"
                [selectedValues]="getSelectedFilterValues(colDef)"
                [searchable]="true"
                (filterApplied)="onFilterApplied(colDef, $event)"
                (filterCleared)="onFilterCleared(colDef)">
              </app-column-filter>
            </span>
          </th>

          <!-- Body Cell -->
          <td mat-cell
              *matCellDef="let row; let rowIndex = index"
              class="text-left"
              [class.pinned-left]="colDef.pinned === 'left'"
              [class.pinned-right]="colDef.pinned === 'right'"
              [ngClass]="colDef.cellClass || ''"
              [ngStyle]="getColumnStyles(colDef)">

            <!-- Custom Cell Renderer -->
            <ng-container *ngIf="colDef.cellRenderer; else defaultRendering">
              <app-cell-renderer-loader
                [renderer]="colDef.cellRenderer"
                [params]="getCellRendererParams(getDataFromNode(row) || row, colDef, rowIndex, colIndex)">
              </app-cell-renderer-loader>
            </ng-container>

            <!-- Default Rendering (no custom renderer) -->
            <ng-template #defaultRendering>
              <!-- Multiple Fields Rendering -->
              <ng-container *ngIf="colDef.fields && colDef.fields.length > 1; else singleField">
                <div *ngFor="let field of colDef.fields" class="field-row">
                  {{ getFieldValue(getDataFromNode(row) || row, field) }}
                </div>
              </ng-container>

              <!-- Single Field Rendering -->
              <ng-template #singleField>
                <ng-container *ngIf="colDef.field">
                  {{ getFormattedFieldValue(getDataFromNode(row) || row, colDef) }}
                </ng-container>
              </ng-template>
            </ng-template>
          </td>

          <!-- Footer Cell -->
           <ng-container *ngIf="hasFooter(colDef)">
          <td mat-footer-cell
              *matFooterCellDef
              class="text-left footer-cell"
              [class.pinned-left]="colDef.pinned === 'left'"
              [class.pinned-right]="colDef.pinned === 'right'"
              [ngClass]="getFooterCellClasses(colDef)"
              [ngStyle]="getCombinedFooterStyles(colDef)">
            <ng-container *ngIf="hasFooter(colDef)">
              <app-footer-cell-renderer-loader
                [renderer]="colDef.footer!.footerCellRenderer"
                [params]="getFooterCellRendererParams(colDef, colIndex)">
              </app-footer-cell-renderer-loader>
            </ng-container>
          </td>
           </ng-container>

        </ng-container>

        <!-- Group Row Column Definition -->
        <ng-container matColumnDef="groupRow">
          <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="p-0">
            <app-group-row
              [groupNode]="getGroupNode(row)!"
              [expanded]="getGroupNode(row)?.expanded || false"
              [indentSize]="mergedConfig.grouping?.indentSize || 20"
              [showAggregates]="mergedConfig.grouping?.showAggregates !== false"
              (toggle)="toggleGroupExpansion(getGroupNode(row)!.key)">
            </app-group-row>
          </td>
        </ng-container>

        <!-- Expandable Detail Row Column Definition -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="p-0">
            <div class="expanded-detail-container"
                 [@detailExpand]="isRowExpanded(getDataFromNode(row) || row) ? 'expanded' : 'collapsed'">
              <ng-container *ngTemplateOutlet="detailTemplate; context: { $implicit: getDataFromNode(row) || row, row: getDataFromNode(row) || row }">
              </ng-container>
            </div>
          </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row
            *matHeaderRowDef="displayedColumns"
            class="bg-white dark:bg-gray-900">
        </tr>

        <!-- Footer Row -->
         <ng-container *ngIf="isFooterEnabled()">
        <tr  mat-footer-row
            *matFooterRowDef="displayedColumns"
            [class.footer-sticky]="mergedConfig.footer?.sticky"
            [style.height]="mergedConfig.footer?.height"
            [ngClass]="mergedConfig.footer?.footerClass || ''"
            [ngStyle]="mergedConfig.footer?.footerStyle || {}"
            class="bg-gray-50 dark:bg-gray-800 border-t-2 border-gray-300 dark:border-gray-600">
        </tr>
         </ng-container>


        <!-- Group Rows (when grouping is enabled) -->
        <tr mat-row
            *matRowDef="let row; columns: ['groupRow']; when: isGroupNode"
            class="group-row-container">
        </tr>

        <!-- Data Rows -->
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns; let rowIndex = index"
            class="border-b hover:bg-gray-50 dark:hover:bg-gray-800"
            [class.bg-blue-50]="isRowSelected(getDataFromNode(row))"
            [class.dark:bg-blue-900]="isRowSelected(getDataFromNode(row))"
            [class.cursor-pointer]="mergedConfig.selection?.selectOnRowClick || mergedConfig.rowExpansion?.expandOnClick"
            (click)="onRowClick(getDataFromNode(row)!, rowIndex, $event)"
            (contextmenu)="onRowContextMenu(getDataFromNode(row)!, rowIndex, $event)">
        </tr>

        <!-- Expandable Detail Row -->
        <ng-container *ngIf="isRowExpansionEnabled()">
          <tr mat-row
              *matRowDef="let row; columns: ['expandedDetail']"
              class="detail-row">
          </tr>
        </ng-container>
      </table>
    </ng-container>

    <!-- ============================================ -->
    <!-- VIRTUAL SCROLLING MODE (CDK Virtual Scroll) -->
    <!-- ============================================ -->
    <ng-container *ngIf="isVirtualScrollingEnabled()">
      <cdk-virtual-scroll-viewport
        [itemSize]="getVirtualScrollItemSize()"
        [minBufferPx]="getVirtualScrollBufferSize() * getVirtualScrollItemSize()"
        [maxBufferPx]="getVirtualScrollBufferSize() * 2 * getVirtualScrollItemSize()"
        class="virtual-scroll-viewport">

        <table class="w-full bg-transparent virtual-scroll-table">
          <!-- Header Row (Fixed) -->
          <thead class="bg-white dark:bg-gray-900">
            <tr>
              <!-- Tree Expand Header -->
              <th *ngIf="isTreeModeEnabled() && mergedConfig.treeData?.showExpandControls !== false"
                  class="text-left"
                  style="width: 50px;">
              </th>

              <!-- Selection Header -->
              <th *ngIf="isSelectionEnabled() && mergedConfig.selection?.showCheckboxColumn"
                  class="text-left"
                  style="width: 60px;">
                <app-selection-column
                  [checked]="isAllSelected()"
                  [indeterminate]="isSomeSelected()"
                  (selectionChange)="toggleSelectAll()">
                </app-selection-column>
              </th>

              <!-- Column Headers -->
              <th *ngFor="let colDef of visibleColumnDefs; let colIndex = index; trackBy: trackByColumnId"
                  class="text-left"
                  [class.pinned-left]="colDef.pinned === 'left'"
                  [class.pinned-right]="colDef.pinned === 'right'"
                  [class.column-filtered]="isColumnFiltered(colDef)"
                  [ngClass]="colDef.headerClass || ''"
                  [ngStyle]="getColumnStyles(colDef)">
                <span class="flex items-center gap-1">
                  <span class="flex items-center gap-1">
                    <!-- Custom Header Renderer or Default Header -->
                    <ng-container *ngIf="hasHeaderRenderer(colDef); else defaultHeaderVirtual">
                      <app-header-renderer-loader
                        [renderer]="colDef.headerRenderer!"
                        [params]="getHeaderRendererParams(colDef, colIndex)">
                      </app-header-renderer-loader>
                    </ng-container>
                    <ng-template #defaultHeaderVirtual>
                      {{ getHeaderName(colDef) }}
                    </ng-template>
                  </span>

                  <!-- Column Filter -->
                  <app-column-filter
                    *ngIf="isFilterableColumn(colDef)"
                    [filterOptions]="getFilterOptions(colDef)"
                    [selectedValues]="getSelectedFilterValues(colDef)"
                    [searchable]="true"
                    (filterApplied)="onFilterApplied(colDef, $event)"
                    (filterCleared)="onFilterCleared(colDef)">
                  </app-column-filter>
                </span>
              </th>
            </tr>
          </thead>

          <!-- Virtual Scrolling Body -->
          <tbody>
            <tr *cdkVirtualFor="let row of dataSource.data; let rowIndex = index; trackBy: trackByRowId"
                class="border-b hover:bg-gray-50 dark:hover:bg-gray-800"
                [class.bg-blue-50]="isRowSelected(row)"
                [class.dark:bg-blue-900]="isRowSelected(row)"
                [class.cursor-pointer]="mergedConfig.selection?.selectOnRowClick"
                [style.height.px]="getVirtualScrollItemSize()"
                (click)="onRowClick(row, rowIndex, $event)"
                (contextmenu)="onRowContextMenu(row, rowIndex, $event)">

              <!-- Tree Expand Cell -->
              <td *ngIf="isTreeModeEnabled() && mergedConfig.treeData?.showExpandControls !== false"
                  class="text-left">
                <app-tree-expand-column
                  [expanded]="isTreeNodeExpanded(row)"
                  [hasChildren]="hasTreeChildren(row)"
                  [level]="getTreeNodeLevel(row)"
                  [indentSize]="getTreeIndentSize()"
                  (toggle)="toggleTreeNodeExpansion(row)">
                </app-tree-expand-column>
              </td>

              <!-- Selection Checkbox Cell -->
              <td *ngIf="isSelectionEnabled() && mergedConfig.selection?.showCheckboxColumn"
                  class="text-left">
                <app-selection-column
                  [checked]="isRowSelected(row)"
                  [disabled]="!isRowSelectable(row)"
                  (selectionChange)="toggleRowSelection(row, rowIndex)">
                </app-selection-column>
              </td>

              <!-- Data Cells -->
              <td *ngFor="let colDef of visibleColumnDefs; let colIndex = index; trackBy: trackByColumnId"
                  class="text-left"
                  [class.pinned-left]="colDef.pinned === 'left'"
                  [class.pinned-right]="colDef.pinned === 'right'"
                  [ngClass]="colDef.cellClass || ''"
                  [ngStyle]="getColumnStyles(colDef)">

                <!-- Custom Cell Renderer -->
                <ng-container *ngIf="colDef.cellRenderer; else defaultRenderingVirtual">
                  <app-cell-renderer-loader
                    [renderer]="colDef.cellRenderer"
                    [params]="getCellRendererParams(row, colDef, rowIndex, colIndex)">
                  </app-cell-renderer-loader>
                </ng-container>

                <!-- Default Rendering (no custom renderer) -->
                <ng-template #defaultRenderingVirtual>
                  <!-- Multiple Fields Rendering -->
                  <ng-container *ngIf="colDef.fields && colDef.fields.length > 1; else singleFieldVirtual">
                    <div *ngFor="let field of colDef.fields" class="field-row">
                      {{ getFieldValue(row, field) }}
                    </div>
                  </ng-container>

                  <!-- Single Field Rendering -->
                  <ng-template #singleFieldVirtual>
                    <ng-container *ngIf="colDef.field">
                      {{ getFieldValue(row, colDef.field) }}
                    </ng-container>
                  </ng-template>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
    </ng-container>

    <!-- Empty State -->
    <div *ngIf="dataSource.data.length === 0 && !loading"
         class="smart-grid-empty-state">
      <mat-icon *ngIf="mergedConfig.emptyState?.showIcon" class="empty-icon">
        {{ mergedConfig.emptyState?.icon || 'inbox' }}
      </mat-icon>
      <p>{{ mergedConfig.emptyState?.message || 'No hay registros para mostrar' }}</p>
    </div>
  </div>

  <!-- Pagination (if enabled) -->
  <div *ngIf="mergedConfig.pagination?.enabled && mergedConfig.pagination?.showPaginator"
       class="smart-grid-pagination">
    <mat-paginator
      [length]="totalRecords !== undefined ? totalRecords : paginationState.totalItems"
      [pageSize]="mergedConfig.pagination.pageSize || 50"
      [pageSizeOptions]="mergedConfig.pagination.pageSizeOptions || [50, 100, 150, 200]"
      [showFirstLastButtons]="mergedConfig.pagination.showFirstLastButtons !== false">
    </mat-paginator>
  </div>

  <!-- Context Menu (OPT-IN - only rendered when enabled) -->
  <app-context-menu
    *ngIf="isContextMenuEnabled()"
    (itemSelected)="onContextMenuItemSelected($event)">
  </app-context-menu>

  </div>

  <!-- Settings Drawer (independent, fixed position) -->
  <div *ngIf="isSettingsPanelEnabled()"
       class="settings-drawer"
       [class.open]="isSettingsPanelOpen"
       [class.drawer-left]="mergedConfig.settingsPanel?.position === 'left'">
      <div class="settings-panel-content">
        <!-- Panel Header -->
        <div class="panel-header">
          <div class="flex items-center gap-2">
            <mat-icon class="text-primary">tune</mat-icon>
            <h2 class="panel-title">Configuración de Tabla</h2>
          </div>
          <button mat-icon-button (click)="closeSettingsPanel()" matTooltip="Cerrar">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <mat-divider></mat-divider>

        <!-- Panel Content -->
        <div class="panel-content">
          <!-- Column Visibility Section -->
          <mat-expansion-panel *ngIf="mergedConfig.settingsPanel?.enableColumnVisibility === true"
                              class="settings-section"
                              expanded>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="section-icon">view_column</mat-icon>
                <span>Columnas Visibles</span>
              </mat-panel-title>
              <mat-panel-description>
                {{ getVisibleColumnsCount() }}/{{ getTotalColumnsCount() }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="section-content">
              <!-- Quick Actions -->
              <div class="quick-actions">
                <button mat-button class="action-button" (click)="showAllColumns()">
                  <mat-icon>visibility</mat-icon>
                  Mostrar Todo
                </button>
                <button mat-button class="action-button" (click)="hideAllColumns()">
                  <mat-icon>visibility_off</mat-icon>
                  Ocultar Todo
                </button>
              </div>

              <mat-divider class="my-2"></mat-divider>

              <!-- Column List -->
              <div class="column-list">
                <div *ngFor="let column of columnVisibilityOptions"
                     class="column-item"
                     (click)="$event.stopPropagation()">
                  <mat-checkbox
                    [(ngModel)]="column.visible"
                    [disabled]="column.disabled"
                    (change)="onColumnToggle(column)"
                    class="w-full">
                    <span class="column-label">{{ column.headerName }}</span>
                    <mat-icon *ngIf="column.disabled"
                              class="lock-icon"
                              matTooltip="Columna obligatoria">
                      lock
                    </mat-icon>
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- Density Section -->
          <mat-expansion-panel *ngIf="mergedConfig.settingsPanel?.enableDensity === true"
                              class="settings-section">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="section-icon">format_line_spacing</mat-icon>
                <span>Densidad de Tabla</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="section-content">
              <mat-radio-group
                [(ngModel)]="selectedDensity"
                (change)="onDensityChange(selectedDensity)"
                class="density-group">
                <mat-radio-button value="compact" class="density-option">
                  <div class="density-label-wrapper">
                    <span class="density-label">Compacta</span>
                    <span class="density-description">Más filas visibles</span>
                  </div>
                </mat-radio-button>

                <mat-radio-button value="comfortable" class="density-option">
                  <div class="density-label-wrapper">
                    <span class="density-label">Cómoda</span>
                    <span class="density-description">Balance entre espacio y datos</span>
                  </div>
                </mat-radio-button>

                <mat-radio-button value="spacious" class="density-option">
                  <div class="density-label-wrapper">
                    <span class="density-label">Espaciosa</span>
                    <span class="density-description">Más espacio entre filas</span>
                  </div>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </mat-expansion-panel>

          <!-- Export Section -->
          <mat-expansion-panel *ngIf="mergedConfig.settingsPanel?.enableExport === true"
                              class="settings-section">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="section-icon">download</mat-icon>
                <span>Exportar Datos</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="section-content">
              <p class="export-description">
                Exporta los datos visibles de la tabla en diferentes formatos
              </p>

              <div class="export-buttons">
                <button mat-stroked-button
                        class="export-button export-csv"
                        (click)="onExport('csv')">
                  <mat-icon>description</mat-icon>
                  Exportar CSV
                </button>

                <button mat-stroked-button
                        class="export-button export-excel"
                        (click)="onExport('excel')">
                  <mat-icon>table_chart</mat-icon>
                  Exportar Excel
                </button>
              </div>
            </div>
          </mat-expansion-panel>
        </div>

        <!-- Panel Footer -->
        <div class="panel-footer">
          <button mat-stroked-button
                  color="warn"
                  class="reset-button w-full"
                  (click)="resetSettings()">
            <mat-icon>restart_alt</mat-icon>
            Restablecer Configuración
          </button>
        </div>
      </div>
  </div>
</div>
